import { MutableRefObject, Ref } from 'react';

export const mergeRefs =
  <T>(...refs: Ref<T>[]) =>
  (node: T | null) =>
    refs.forEach((ref) => {
      if (typeof ref === 'function') ref(node);
      else if (ref) (ref as MutableRefObject<T | null>).current = node;
    });
